import React from 'react'

interface ISelectButtonData {
    id?: any
    value?: string
}

interface IProps {
    className?: string
    onChange: (e?: any) => void
    data: ISelectButtonData[]
    activeValue: ISelectButtonData
}

const WizSelectButton: React.FC<IProps> = ({className, onChange, data, activeValue}) => {
    const renderItemLine = item => {
        if (data?.indexOf(item) != data?.length - 1) {
            return 'border-r border-r-line02'
        }
    }

    const renderActiveColor = item => {
        if (activeValue?.id === item?.id) {
            return 'bg-sub_blue text-white'
        } else {
            return 'bg-white'
        }
    }

    return (
        <div
            className={`flex items-center border border-line02 rounded-[5px] overflow-hidden cursor-pointer w-min h-min ${className} `}>
            {data?.map(item => (
                <div
                    key={item?.id}
                    id={item?.id}
                    onClick={() => onChange(item)}
                    className={`px-[20px] py-[7px] flex-1 text-body2 whitespace-nowrap text-font03 ${renderItemLine(
                        item,
                    )} 
                    ${renderActiveColor(item)}`}>
                    {item.value}
                </div>
            ))}
        </div>
    )
}

export default WizSelectButton
